import React from 'react';

import { DiscountSectionProps } from '@/Order/types/orderTypes';
import { formatPrice, getCurrencySymbol } from '@/shared/utils/priceUtils';

const formatCurrency = (amount: number, currency: string) => {
  const currencyCode = currency as 'KRW' | 'USD';
  const symbol = getCurrencySymbol(currencyCode);
  const formattedAmount = formatPrice(amount, currencyCode);
  return `${symbol}${formattedAmount}`;
};

const getPublicMemoContent = (orderMemo: DiscountSectionProps['orderMemo']) => {
  if (
    Array.isArray(orderMemo) &&
    orderMemo.length > 0 &&
    orderMemo.some((memo) => memo.type === 'PUBLIC')
  ) {
    return orderMemo
      .filter((memo) => memo.type === 'PUBLIC')
      .map((memo) => memo.content)
      .join(', ');
  }
  return 'No memo available';
};

const DiscountHistorySection: React.FC<DiscountSectionProps> = ({
  beforeDiscountAmount,
  discountAmount,
  afterDiscountAmount,
  currencyCode,
  orderMemo,
}) => {
  return (
    <div className="flex flex-col rounded border border-gray-200 bg-white shadow-sm">
      <div className="p-5">
        <h3 className="text-base font-medium text-[#1D1D1D]">
          Discount history
        </h3>
      </div>
      <div className="space-y-3 px-4 pb-4">
        <div className="flex items-center justify-between rounded border border-[#F1F1F1] p-4">
          <div>
            <p className="text-xs text-[#888888]">
              {getPublicMemoContent(orderMemo)}
            </p>
            <p className="mt-3 text-sm text-[#1D1D1D]">
              Before Discount:{' '}
              {formatCurrency(beforeDiscountAmount, currencyCode)}
            </p>
            <p className="mt-1 text-sm text-[#1D1D1D]">
              Discount Amount: -{formatCurrency(discountAmount, currencyCode)}
            </p>
          </div>
          <div className="text-right">
            <p className="text-xs text-[#646464]">Total</p>
            <p className="text-sm font-semibold text-[#1D1D1D]">
              {formatCurrency(afterDiscountAmount, currencyCode)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountHistorySection;
